import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaGithub, FaLinkedin, FaInstagram, FaEnvelope } from "react-icons/fa";
import { FaX } from "react-icons/fa6";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const socialLinks = {
    github: {
      url: "https://github.com/mugisha19",
      icon: <FaGithub size={20} />,
    },
    x: {
      url: "https://x.com/habiya_adolphe",
      icon: <FaX size={20} />,
    },
    linkedin: {
      url: "https://www.linkedin.com/in/habiyaremye-adolphe-1968792aa/",
      icon: <FaLinkedin size={20} />,
    },
    instagram: {
      url: "https://www.instagram.com/smurkk.durkio/",
      icon: <FaInstagram size={20} />,
    },
    gmail: {
      url: "mailto:habiyaadolphe19@gmail.com",
      icon: <FaEnvelope size={20} />,
    },
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [activeField, setActiveField] = useState("");

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          "form-name": "contact",
          ...formData,
        }).toString(),
      });

      if (response.ok) {
        setSubmitStatus("success");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      setSubmitStatus("error");
    }

    setIsSubmitting(false);
    setTimeout(() => setSubmitStatus(null), 5000);
  };

  const contactMethods = [
    {
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      ),
      label: "Email",
      value: "habiyaadolphe19@gmail.com",
      link: "mailto:habiyaadolphe19@gmail.com",
      description: "Drop me a line anytime",
    },
    {
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      ),
      label: "Phone",
      value: "+250 786 108 587",
      link: "tel:+250786108587",
      description: "Mon-Fri from 8am to 10pm",
    },
    {
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      ),
      label: "Location",
      value: "Kigali, Rwanda",
      description: "Available for remote work",
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
      ),
      label: "LinkedIn",
      value: "Habiyaremye Adolphe",
      link: "https://www.linkedin.com/in/habiyaremye-adolphe-1968792aa/",
      description: "Let's connect professionally",
    },
  ];

  return (
    <section
      id="contact"
      className="py-24 px-6 bg-gray-200 dark:bg-slate-950 text-gray-900 dark:text-white relative overflow-hidden"
    >
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23888888' fill-opacity='1'%3E%3Ccircle cx='7' cy='7' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        ></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Header */}
        <motion.div
          className="text-center mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <motion.div
            className="inline-block mb-4"
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <span className="inline-flex items-center px-4 py-2 bg-white/80 dark:bg-slate-800/50 text-blue-700 dark:text-blue-300 text-sm font-medium rounded-full border border-gray-200/50 dark:border-slate-700/50">
              Get In Touch
            </span>
          </motion.div>

          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 dark:text-white">
            Let's Work Together
          </h2>

          <p className="text-lg text-gray-600 dark:text-slate-400 max-w-2xl mx-auto leading-relaxed">
            I'm always interested in new opportunities and collaborations.
            Whether you have a project in mind or just want to chat, I'd love to
            hear from you.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16">
          {/* Contact Form */}
          <motion.div
            className="lg:col-span-3"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="bg-white/80 dark:bg-slate-800/40 backdrop-blur-sm rounded-2xl p-8 border border-gray-200/50 dark:border-slate-700/30">
              <h3 className="text-2xl font-semibold mb-6 text-gray-900 dark:text-white">
                Send a Message
              </h3>

              {/* Hidden form for Netlify to detect */}
              <form
                name="contact"
                data-netlify="true"
                netlify-honeypot="bot-field"
                hidden
              >
                <input type="text" name="name" />
                <input type="email" name="email" />
                <input type="text" name="subject" />
                <textarea name="message"></textarea>
              </form>

              <form onSubmit={handleSubmit} className="space-y-6">
                <input type="hidden" name="form-name" value="contact" />
                <p className="hidden">
                  <label>
                    Don't fill this out: <input name="bot-field" />
                  </label>
                </p>

                <div className="grid md:grid-cols-2 gap-6">
                  <div className="relative">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      onFocus={() => setActiveField("name")}
                      onBlur={() => setActiveField("")}
                      required
                      className={`w-full px-4 py-3 bg-gray-100 dark:bg-slate-700/50 border rounded-lg text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-slate-400 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        activeField === "name"
                          ? "border-blue-500"
                          : "border-gray-300 dark:border-slate-600"
                      }`}
                      placeholder="Full Name"
                    />
                  </div>

                  <div className="relative">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      onFocus={() => setActiveField("email")}
                      onBlur={() => setActiveField("")}
                      required
                      className={`w-full px-4 py-3 bg-gray-100 dark:bg-slate-700/50 border rounded-lg text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-slate-400 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        activeField === "email"
                          ? "border-blue-500"
                          : "border-gray-300 dark:border-slate-600"
                      }`}
                      placeholder="Email Address"
                    />
                  </div>
                </div>

                <div className="relative">
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    onFocus={() => setActiveField("subject")}
                    onBlur={() => setActiveField("")}
                    required
                    className={`w-full px-4 py-3 bg-gray-100 dark:bg-slate-700/50 border rounded-lg text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-slate-400 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                      activeField === "subject"
                        ? "border-blue-500"
                        : "border-gray-300 dark:border-slate-600"
                    }`}
                    placeholder="Subject"
                  />
                </div>

                <div className="relative">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    onFocus={() => setActiveField("message")}
                    onBlur={() => setActiveField("")}
                    rows={6}
                    required
                    className={`w-full px-4 py-3 bg-gray-100 dark:bg-slate-700/50 border rounded-lg text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-slate-400 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none ${
                      activeField === "message"
                        ? "border-blue-500"
                        : "border-gray-300 dark:border-slate-600"
                    }`}
                    placeholder="Tell me about your project..."
                  />
                </div>

                {/* Status Message */}
                {submitStatus === "success" && (
                  <div className="flex items-center gap-2 p-3 bg-green-100 dark:bg-green-900/30 border border-green-300 dark:border-green-700 rounded-lg text-green-700 dark:text-green-400 text-sm">
                    <span>✅</span> Message sent successfully! I'll get back to
                    you soon.
                  </div>
                )}
                {submitStatus === "error" && (
                  <div className="flex items-center gap-2 p-3 bg-red-100 dark:bg-red-900/30 border border-red-300 dark:border-red-700 rounded-lg text-red-700 dark:text-red-400 text-sm">
                    <span>❌</span> Something went wrong. Please try emailing me
                    directly.
                  </div>
                )}

                <motion.button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full py-3 px-6 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed relative overflow-hidden group"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <span
                    className={`transition-opacity duration-300 ${
                      isSubmitting ? "opacity-0" : "opacity-100"
                    }`}
                  >
                    Send Message
                  </span>
                  {isSubmitting && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    </div>
                  )}
                </motion.button>
              </form>
            </div>
          </motion.div>

          {/* Contact Information */}
          <motion.div
            className="lg:col-span-2"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">
                  Get in Touch
                </h3>
                <p className="text-gray-600 dark:text-slate-400 leading-relaxed">
                  I typically respond within 24 hours. Looking forward to
                  discussing your next project!
                </p>
              </div>

              <div className="space-y-6">
                {contactMethods.map((method, index) => (
                  <motion.div
                    key={index}
                    className="group"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 * index }}
                    viewport={{ once: true }}
                  >
                    {method.link ? (
                      <a
                        href={method.link}
                        target={
                          method.link.startsWith("http") ? "_blank" : undefined
                        }
                        rel={
                          method.link.startsWith("http")
                            ? "noopener noreferrer"
                            : undefined
                        }
                        className="flex items-start gap-4 p-4 rounded-xl transition-all duration-300 hover:bg-gray-100 dark:hover:bg-slate-800/50 border border-transparent hover:border-gray-200 dark:hover:border-slate-700/50"
                      >
                        <div className="flex-shrink-0 w-12 h-12 bg-blue-600 text-white rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                          {method.icon}
                        </div>
                        <div>
                          <h4 className="font-medium text-gray-900 dark:text-white mb-1">
                            {method.label}
                          </h4>
                          <p className="text-gray-600 dark:text-slate-400 font-mono text-sm mb-1">
                            {method.value}
                          </p>
                          <p className="text-gray-500 dark:text-slate-500 text-sm">
                            {method.description}
                          </p>
                        </div>
                      </a>
                    ) : (
                      <div className="flex items-start gap-4 p-4">
                        <div className="flex-shrink-0 w-12 h-12 bg-blue-600 text-white rounded-lg flex items-center justify-center">
                          {method.icon}
                        </div>
                        <div>
                          <h4 className="font-medium text-gray-900 dark:text-white mb-1">
                            {method.label}
                          </h4>
                          <p className="text-gray-600 dark:text-slate-400 font-mono text-sm mb-1">
                            {method.value}
                          </p>
                          <p className="text-gray-500 dark:text-slate-500 text-sm">
                            {method.description}
                          </p>
                        </div>
                      </div>
                    )}
                  </motion.div>
                ))}
              </div>

              {/* Social Links */}
              <div className="pt-8 border-t border-gray-300 dark:border-slate-700">
                <h4 className="font-medium text-gray-900 dark:text-white mb-4">
                  Follow me
                </h4>
                <div className="flex gap-4">
                  {Object.keys(socialLinks).map((platform, index) => (
                    <motion.a
                      key={platform}
                      href={socialLinks[platform].url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 bg-gray-300 dark:bg-slate-700 text-gray-700 dark:text-slate-300 rounded-lg flex items-center justify-center hover:bg-blue-600 hover:text-white transition-all duration-300"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      initial={{ opacity: 0, scale: 0.8 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.3, delay: 0.1 * index }}
                      viewport={{ once: true }}
                      aria-label={platform}
                    >
                      {socialLinks[platform].icon}
                    </motion.a>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom CTA */}
        <motion.div
          className="text-center mt-20 pt-12 border-t border-gray-300 dark:border-slate-700"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h3 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">
            Ready to start your project?
          </h3>
          <p className="text-gray-600 dark:text-slate-400 mb-6 max-w-xl mx-auto">
            Let's chat about the way we can use reliable programming and a
            clean, modern appearance to bring out your thoughts.
          </p>
          <motion.a
            href="mailto:habiyaadolphe19@gmail.com"
            className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-all duration-300"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span>Start a conversation</span>
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}
